require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-vv-y-1-q.json") })
        }
      }, "path---photos-professional-vv-y-1-q");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-vv-y-1-q!./.cache/json/photos-professional-vv-y-1-q.json
// module id = 936
// module chunks = 231608221292675